export enum LinkExpirationMeaning {
	Never ='never',
	SingleUse = 'singleuse',
	Date = 'date',
	Days = 'days',
	Hours = 'hours',
	Minutes = 'minutes'
}


// WEBPACK FOOTER //
// ./src/phoenix/domain/sharing.ts